import Title from 'antd/lib/typography/Title';
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useGetFullQuery, useGetPriceChartQuery } from "../../../services/BBFinanceAPI";
import Spinner from '../../utils/Spinner';
import {IoMdArrowDropdownCircle, IoMdArrowDropupCircle} from "react-icons/io";
import {BiRupee} from "react-icons/bi";
import './StockDetails.css';
import  'bootstrap/js/dist/tab';
import StockLineChart from '../../containers/Charts/StockLineChart';
import StockStatistics from './StockStatistics';
import StockFinancials from './StockFinancials';
import StockNews from './StockNews/StockNews';
import { addStock } from '../../../redux/actions/portfolioActions';
import { useDispatch, useSelector } from 'react-redux';
import CircularSpinner from '../../utils/CircularSpinner';


const StockDetails = () => {
    const {ticker} = useParams();
    const userID = useSelector(state => state?.user?.user?._id);
    const user_portfolio = useSelector(state => state?.portfolio?.portfolio_list);
    const dispatch = useDispatch();
    const [interval, setInterval] = useState('y1')
    const {data, isFetching} = useGetFullQuery(ticker);
    const {data:chartData, isFetching:isChartFetching} = useGetPriceChartQuery({ticker: ticker, interval: interval});
    const tickerName = ticker.toUpperCase();
    const stockDetails = data?.result?.[tickerName];
    const stockChartDetails = chartData?.result?.[tickerName];
    const [addLoading, setAddLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    // Checking if the stock is included in the portfolio
    const isIncluded = user_portfolio?.some((stock) => stock.bbFinanceSymbol === stockDetails?.symbol);
    
    // Change and Change Percentage for Chart
    const change = stockChartDetails?.security?.open - stockChartDetails?.security?.prevClose;
    const changePercent = (change/stockChartDetails?.security?.prevClose)*100 || 0;

    // Array of available intervals
    const intervals = ['d1', 'd3', 'ytd', 'm1', 'm3', 'm6', 'y1', 'y5'];
   
    // Handler to change intervals
    const onIntervalChange = (e) => {
        setInterval(e.target.id);
    }

    // Handler for adding the stock to the user portfolio
    const addStockPortfolio = async (data) => {
        // Accumulating the data for the backend
        const stockData = {
            userID: userID,
            name: stockDetails.name,
            symbol: stockDetails.symbol,
            ticker: stockDetails.ticker,
            currency: stockDetails.currency,
            exchange: stockDetails.exchange,
            sector: stockDetails.sector,
            subSector: stockDetails.subSector,
            industry: stockDetails.industry,
            marketCap: stockDetails.marketCap
        }
        setAddLoading(true);
        // Generating the request
        const response = await dispatch(addStock(stockData));
        
        // Displaying success or failure message
        if(response?.status === 200) {
            setSuccess("Stock has been added successfully to the portfolio");
        }else{
            const errorMessage = response?.data?.errorMessage;
            setError(errorMessage);
        }
        setAddLoading(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        //eslint-disable-next-line
    }, [])
    
    const options1 = { style: 'currency', currency: 'INR' };
    const numberFormat1 = new Intl.NumberFormat('en-IN', options1);

    return (    
        <div className="d-flex flex-column pt-3 px-5 stockDetailsContainer">
            {
                isFetching ? 
                <Spinner /> : 
                (
                   // Info Display
                   <div className="my-4">
                        <div className="stock-box">
                                <Title level={3}>{stockDetails?.name}</Title>
                                <div className="d-flex ">
                                    <span className="mx-2">
                                        <strong>
                                            <small>{stockDetails?.last}</small>
                                        </strong>
                                    </span>
                                    <span className="mx-2">
                                        {
                                            stockDetails?.netChange < 0 ? (
                                                <IoMdArrowDropdownCircle fill="#bf0000"/>
                                            ) : (
                                                <IoMdArrowDropupCircle fill="#028c00"/>
                                            )
                                        }
                                        <strong style={{color: `${stockDetails?.netChange < 0? "#dc3545": "#198754"}`}}>
                                            <small className="mx-1">{stockDetails?.netChange}</small>
                                        </strong>
                                    </span>
                                    <span className="mx-2">
                                        <strong style={{color: `${stockDetails?.netChange < 0? "#ff0000": "#07ad0a"}`}}>
                                            <small>
                                                {stockDetails?.pctChange} %
                                            </small>
                                        </strong>
                                    </span>
                                </div>
                                <p >
                                    {stockDetails?.info}
                                </p>
                                <div className="w-100 my-1">
                                {
                                    success 
                                    ? 
                                        (
                                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                                {success}
                                                <button type="button"  onClick = {() => setSuccess("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div>
                                        ) : 
                                        <></>
                                }
                                {
                                    error ? 
                                        (
                                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                {error}
                                                <button type="button" onClick = {() => setError("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">

                                                </button>
                                            </div>
                                        ) : 
                                            <></>
                                }
                                </div>
                                <div>
                                    <button className="d-inline-block btn btn-primary btn-sm me-4"
                                            style={{backgroundColor: "#0063bf"}}
                                            disabled={addLoading || isIncluded}
                                            onClick = {() => {addStockPortfolio()}}
                                    >
                                        <small>
                                            {
                                                addLoading 
                                                ? <CircularSpinner /> 
                                                : (isIncluded ? <strong>Added</strong> : <strong>Add to Portfolio</strong>)
                                            }
                                        </small>
                                    </button>
                                </div>
                        </div>
                        <hr/>

                        {/* Chart Display */}

                        {
                            isChartFetching
                            ? <Spinner />
                            : (
                                <div className="w-100 mt-5">
                                    <Title level={4}>Price Chart</Title> 
                                    <div className="d-flex justify-content-between align-items-center my-5 mx-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex flex-column me-5">
                                                <strong>High</strong>
                                                <span>{stockChartDetails.high}</span>
                                            </div>
                                            <div className="d-flex flex-column me-5">
                                                <strong>Low</strong>
                                                <span>{stockChartDetails.low}</span>
                                            </div>
                                            <div className="d-flex flex-column me-5">
                                                <strong>Returns</strong>
                                                <span style={{color: `${changePercent < 0? "#ff0000": "#07ad0a"}`}}>
                                                    {
                                                        changePercent < 0 
                                                        ? (
                                                            <IoMdArrowDropdownCircle fill="#bf0000"/>) 
                                                        : (
                                                            <IoMdArrowDropupCircle fill="#028c00"/>
                                                        )
                                                    }
                                                    <strong className="mx-1">{Math.round(changePercent)} %</strong>
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            {
                                                intervals?.map((tempInterval, i) => (
                                                    <button key={i} 
                                                    className={`interval-button ${tempInterval===interval ? "active-interval" : ""}`} 
                                                    onClick={onIntervalChange} 
                                                    id={tempInterval}>
                                                        {
                                                            <small>{tempInterval.toUpperCase()}</small>
                                                        }
                                                    </button>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <StockLineChart stockHistory={stockChartDetails} onIntervalChange={onIntervalChange} change={change}/>
                                </div>
                            )
                        }
                        <hr/>

                        {/* Company Essentials Display */}

                        <div className="w-100 mt-5">
                            <Title level={4}>Company Essentials</Title>
                            <div className="d-flex justify-content-between align-items-center my-5 mx-4">
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        Market Cap
                                    </strong>
                                    <span>
                                        {numberFormat1.format(Math.round(stockDetails?.marketCap))}
                                        {
                                            stockDetails?.currency === "INR"
                                            ? <BiRupee />
                                            : <></>
                                        }
                                    </span>
                                </div>
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        Volume
                                    </strong>
                                    <span>
                                        {stockDetails?.volume}
                                    </span>
                                </div>
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        1Y Return
                                    </strong>
                                    <strong style={{color: `${stockDetails?.totalReturn1Y < 0? "#dc3545": "#198754"}`}}>
                                        { stockDetails?.totalReturn1Y < 0 ? <IoMdArrowDropdownCircle fill="#bf0000"/> : <IoMdArrowDropupCircle fill="#028c00"/> }
                                        &nbsp;
                                        { stockDetails?.totalReturn1Y }%
                                    </strong>
                                </div>
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        Sector
                                    </strong>
                                    <span>
                                        {stockDetails?.sector}
                                    </span>
                                </div>
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        Sub Sector
                                    </strong>
                                    <span>
                                        {stockDetails?.subSector}
                                    </span>
                                </div>
                                <div className="d-flex flex-column"> 
                                    <strong>
                                        Sector Change(1D)
                                    </strong>
                                    <strong style={{color: `${stockDetails?.sectorPercentChange1Day < 0? "#dc3545": "#198754"}`}}>
                                        { stockDetails?.sectorPercentChange1Day ? <IoMdArrowDropdownCircle fill="#bf0000"/> : <IoMdArrowDropupCircle fill="#028c00"/> }
                                        &nbsp;
                                        {stockDetails?.sectorPercentChange1Day} %
                                    </strong>
                                </div>
                            </div> 
                        </div>
                        
                        <hr/>

                        {/* Statistics and Financial Tab */}

                        <div className="w-100 my-5 ">
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item mx-2" role="presentation">
                                    <button className="nav-link btn-sm finance-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                                        Statistics
                                    </button>
                                </li>
                                <li className="nav-item mx-2" role="presentation">
                                    <button className="nav-link btn-sm finance-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                                        Financials
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                    <StockStatistics ticker={ticker}/>
                                </div>
                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                    <StockFinancials ticker={ticker}/>
                                </div>
                            </div>
                        </div>

                        <hr/>

                        {/* Stock News */}

                        <div className="w-100 mt-5">
                            <Title level={4}>Stock News</Title>
                            <StockNews stock={stockDetails?.name}/>
                        </div>
                   </div>
                )
            }
        </div>
    )
}

export default StockDetails
